// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__20rPA","label":"CategoryService_label__Ow71d","location":"CategoryService_location__1peZG"};